import React, { FC, memo, useMemo } from 'react';
import { useFormikContext } from 'formik';
import _isEmpty from 'lodash/isEmpty';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { gqlProfileSearchInput } from '@minecraft.graphql-types';
import { initialRadioButtonSkillLevelValue } from '../../../shared/config';
import { FiltersNameEnum, SelectOption, FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';
import SkillsOperator from './SkillsOperator';

type Props = {
  refetchProfileFilterData?: ({ input: object, resultType: string }) => void;
  appliedQueryInput?: gqlProfileSearchInput;
} & FilterData;

const Skills: FC<Props> = ({ name, label, refetchProfileFilterData, appliedQueryInput }) => {
  const { values, setFieldValue } = useFormikContext();

  const { isSearching, getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.skills);

  const handleChange = (currentOptions: SelectOption[]): void => {
    if (!_isEmpty(values[FiltersNameEnum.skillLevels]) && _isEmpty(currentOptions)) {
      setFieldValue(FiltersNameEnum.skillLevels, initialRadioButtonSkillLevelValue, false);
    }
  };

  const options = useMemo(() => getMatchedSearchOptions(name), [name, getMatchedSearchOptions]);

  return (
    <>
      <Label>{label}</Label>
      <SkillsOperator appliedQueryInput={appliedQueryInput} refetchProfileFilterData={refetchProfileFilterData} />
      <CheckboxListWithSearch
        withFormik
        withSearch={!isSearching}
        name={name}
        options={options}
        onOptionsChange={handleChange}
        appliedQueryInput={appliedQueryInput}
        refetchProfileFilterData={refetchProfileFilterData}
      />
    </>
  );
};

export default memo(Skills);
